import {FieldProps} from "formik";
import _ from "lodash";
import {useCallback} from "react";
import {IInputFieldProps} from "@/models/form-controls.model";
import {PasswordInput} from "@/components/ui/password-input";
import {inputVariants} from "@/constants/animations.ts";
import {motion} from "framer-motion";

interface FormikPasswordInputProps extends IInputFieldProps {
    formikField: FieldProps;
    fullWidth?: boolean;
}

const FormPasswordInput = (props: FormikPasswordInputProps) => {
    const {
        formikField,
        onChange,
        label,
        placeholder,
        icon,
        ...otherProps
    } = props;

    const {field, form} = formikField;
    const {name, value} = field;
    const {setFieldTouched, touched, errors, setFieldValue} = form;
    const hasError = _.get(touched, name) && !!_.get(errors, name);

    const textChangeHandler = useCallback((text: string) => {
        setFieldValue(name, text);
        setFieldTouched(name);
        if (onChange) {
            onChange(text);
        }
    }, [setFieldValue, setFieldTouched, name, onChange]);

    // const onInputBlur = useCallback(() => {
    //     // handleBlur(name);
    //     // setFieldTouched(name);
    // }, [name, handleBlur, setFieldTouched]);


    // const handleOnBlur = useCallback((value: any) => {
    //     if (onBlur) {
    //         // onBlur(value);
    //     }
    // }, [onBlur]);

    return (
        <motion.div variants={inputVariants}
                    initial="initial"
                    animate="animate">
            <PasswordInput
                placeholder={placeholder}
                fullWidth={true}
                onChange={textChangeHandler}
                label={label}
                hasError={hasError}
                value={value}
                icon={icon}
                // onBlur={onInputBlur}
                // onFocus={handleOnBlur}
                errorMessage={hasError ? (_.get(errors, name) as string) : undefined}
                {...otherProps}
            />
        </motion.div>
    );
};

export default FormPasswordInput;
